import { createSelector } from "reselect"
import { STYLE_AGGREGATION_OPTIONS } from "helpers/factorClassification"

import { getMustAggregateFactors, getStyleExposureAggregation } from "modules/portfolio-root/selectors/portfolios"

export const getStyleAggregation = createSelector(
  [getMustAggregateFactors, getStyleExposureAggregation],
  (mustAggregateFactors, styleExposureAggregation) => {
    return {
      displayAggregationToggle: mustAggregateFactors,
      aggregation: styleExposureAggregation,
      aggregationOptions: STYLE_AGGREGATION_OPTIONS,
    }
  },
)
